import { ActionReducerMap, createReducer, on } from "@ngrx/store";
import { Action, ActionReducer } from "@ngrx/store/src/models";
import { LearningRecordTabEffect } from "./learning-record-tab/learning-record-tab.effects";
import { LearningRecordTabReducer } from "./learning-record-tab/learning-record-tab.reducer";
import { LearningRecordTabState } from "./learning-record-tab/learning-record-tab.state";
import { SkillsCheckTabEffects } from "./skills-check-tab/skills-check-tab.effects";
import { SkillsCheckTabReducers } from "./skills-check-tab/skills-check-tab.reducers";
import { SkillsCheckState } from "./skills-check-tab/skills-check-tab.state";
import { SetCourseId } from "./_store.actions";
import { onStoreInit } from "./_store.meta-reducer";
import { FormAdministratorState } from "./form-administrator/form-administrator.state";
import { FormAdministratorEffects } from "./form-administrator/form-administrator.effects";
import { FormAdministratorReducers } from "./form-administrator/form-administrator.reducers";
import { LearningPlanState } from "./learning-plan/learning-plan.state";
import { LearningPlanEffects } from "./learning-plan/learning-plan.effects";
import { LearningPlanReducers } from "./learning-plan/learning-plan.reducer";
import { SkillsCheckQandAState } from "./skills-check-q-and-a/skills-check-q-and-a.state";
import { SkillsCheckQandAReducers } from "./skills-check-q-and-a/skills-check-q-and-a.reducer";
import { SkillsCheckQandAEffects } from "./skills-check-q-and-a/skills-check-q-and-a.effects";
import { EditAdministratorState } from "./edit-administrator/edit-administrator.state";
import { EditAdministratorReducers } from "./edit-administrator/edit-administrator.reducers";
import { EditAdministratorEffects } from "./edit-administrator/edit-administrator.effects";
import { OrganisationState } from "./organisation/organisation.state";
import { OrganisationEffects } from "./organisation/organisation.effects";
import { OrganisationReducers } from "./organisation/organisation.reducers";
import { CentreState } from "./centre/centre.state";
import { CentreEffects } from "./centre/centre.effects";
import { CentreReducers } from "./centre/centre.reducers";
import { NavigationState } from "./navigation/navigation.state";
import { NavigationReducers } from "./navigation/navigation.reducers";
import { NavigationStateEffects } from "./navigation/navigation.effects";
import { GroupState } from "./group/group.state";
import { GroupEffects } from "./group/group.effects";
import { GroupReducers } from "./group/group.reducers";
import { TutorState } from "./tutor/tutor.state";
import { TutorReducers } from "./tutor/tutor.reducers";
import { TutorEffects } from "./tutor/tutor.effects";
import { RoleState } from "./role/role.state";
import { RoleEffects } from "./role/role.effects";
import { RoleReducers } from "./role/role.reducers";
import { UserProfileEffects } from "./user-profile/user-profile.effects";
import { UserProfileReducer } from "./user-profile/user-profile.reducers";
import { UserProfileState } from "./user-profile/user-profile.state";
import { CourseState } from "./course/course.state";
import { CourseEffects } from "./course/course.effects";
import { CourseReducers } from "./course/course.reducers";
import { CreateLearnerState } from "./create-learner/create-learner.state";
import { CreateLearnerEffects } from "./create-learner/create-learner.effects";
import { CreateLearnerReducers } from "./create-learner/create-learner.reducers";
import { LearnerState } from "./learner/learner.state";
import { LearnerReducers } from "./learner/learner.reducers";
import { LearnerEffects } from "./learner/learner.effects";
import { DateProviderEffects } from "./date-provider/date-provider.effect";
import { DateProviderState } from "./date-provider/date-provider.state";
import { DateProviderReducer } from "./date-provider/date-provider.reducer";
import { EditLearnerState } from "./edit-learner/edit-learner.state";
import { EditLearnerEffects } from "./edit-learner/edit-learner.effects";
import { EditLearnerReducers } from "./edit-learner/edit-learner.reducers";
import { ListAdministratorState } from "./list-administrator/list-administrator.state";
import { ListAdminstratorReducers } from "./list-administrator/list-administrator.reducers";
import { ListAdministratorEffects } from "./list-administrator/list-administrator.effects";
import { TutorEditEffects } from "./tutor-edit/tutor-edit.effects";
import { TutorEditState } from "./tutor-edit/tutor-edit.state";
import { TutorEditReducers } from "./tutor-edit/tutor-edit.reducers";
import { TutorDeleteState } from "./tutor-delete/tutor-delete.state";
import { TutorDeleteEffects } from "./tutor-delete/tutor-delete.effects";
import { TutorDeleteReducers } from "./tutor-delete/tutor-delete.reducers";
import { LearnerCourseState } from "./learner-course/learner-course.state";
import { LearnerCourseReducers } from "./learner-course/learner-course.reducers";
import { LearnerCourseEffects } from "./learner-course/learner-course.effects";
import { CourseContentMetadataState } from "./course-content-metadata/course-content-metadata.state";
import { CourseContentMetadataEffects } from "./course-content-metadata/course-content-metadata.effects";
import { CourseContentMetadataReducers } from "./course-content-metadata/course-content-metadata.reducers";
import { LearningTrackingState } from "./learning-tracking/learning-tracking.state";
import { LearningTrackingStateEffects } from "./learning-tracking/learning-tracking.effects";
import { LearningTrackingReducers } from "./learning-tracking/learning-tracking.reducers";
import { EditGroupState } from "./edit-group/edit-group.state";
import { EditGroupReducers } from "./edit-group/edit-group.reducers";
import { EditGroupEffects } from "./edit-group/edit-group.effects";
import { LearnerOfflineActivityState } from "./learner-offline-activity/learner-offline-activity.state";
import { LearnerOfflineActivityEffects } from "./learner-offline-activity/learner-offline-activity.effects";
import { LearnerOfflineActivityReducers } from "./learner-offline-activity/learner-offline-activity.reducers";
import { LearningResourcesEffects } from "./learning-resource/learning-resource.effects";
import { LearningResourcesState } from "./learning-resource/learning-resource.state";
import { LearningResourcesReducers } from "./learning-resource/learning-resource.reducers";
import { ExternalInitialAssessmentState } from "./external-initial-assessment/external-initial-assessment.state";
import { ExternalInitialAssessmentEffects } from "./external-initial-assessment/external-initial-assessment.effects";
import { ExportInitialAssessmentReducers } from "./external-initial-assessment/external-initial-assessment.reducers";
import { AssessmentProfileState } from "./assessment-profile/assessment-profile.state";
import { AssessmentProfileReducers } from "./assessment-profile/assessment-profile.reducers";
import { AssessmentProfileEffects } from "./assessment-profile/assessment-profile.effects";
import { LearnerResourcesState } from "./learner-resources/learner-resources.state";
import { LearnerResourcesEffects } from "./learner-resources/learner-resources.effects";
import { LearnerResourcesReducers } from "./learner-resources/learner-resources.reducers";
import { TransferLearnerState } from "./transfer-learner/transfer-learner.state";
import { TransferLearnerReducers } from "./transfer-learner/transfer-learner.reducers";
import { TransferLearnerEffects } from "./transfer-learner/transfer-learner.effects";
import { EventHistoryReducers } from "./event-history/event-history.reducers";
import { EventHistoryEffects } from "./event-history/event-history.effects";
import { EventHistoryState } from "./event-history/event-history.state";
import { DigLitSelfAssessmentState } from "./dig-lit-self-assessment/dig-lit-self-assessment.state";
import { DigLitSelfAssessmentEffects } from "./dig-lit-self-assessment/dig-lit-self-assessment.effect";
import { DigLitSelfAssessmentReducer } from "./dig-lit-self-assessment/dig-lit-self-assessment.reducer";
import { ResetMFAState } from "./reset-mfa/reset-mfa.state";
import { ResetMFAEffects } from "./reset-mfa/reset-mfa.effects";
import { ResetMFAReducers } from "./reset-mfa/reset-mfa.reducers";
import { LearnerReportState } from "./report/learner-report/learner-report.state";
import { LearnerReportEffects } from "./report/learner-report/learner-report.effects";
import { LearnerReportReducers } from "./report/learner-report/learner-report.reducers";
import { WrittenAssignmentRecordState } from "./written-assignments-record/written-assignment-record.state";
import { WrittenAssignmentRecordEffects } from "./written-assignments-record/written-assignment-record.effects";
import { WrittenAssignmentRecordsReducers } from "./written-assignments-record/written-assignment-record.reducers";
import { ImportReducers } from "./import/import.reducers";
import { ImportState } from "./import/import.state";
import { ImportEffects } from "./import/import.effects";
import { ImportExternalResultsState } from "./import-external-results/import-external-results.state";
import { ImportExternalResultsEffects } from "./import-external-results/import-external-results.effects";
import { ImportExternalResultsReducers } from "./import-external-results/import-external-results.reducers";
import { ImportBatchDisableDeleteState } from "./import-batch-disable-delete/import-batch-disable-delete.state";
import { ImportBatchDisableDeleteReducers } from "./import-batch-disable-delete/import-batch-disable-delete.reducers";
import { ImportBatchDisableDeleteEffects } from "./import-batch-disable-delete/import-batch-disable-delete.effects";
import { AggregateReportState } from "./report/aggregate-report/aggregate-report.state";
import { AggregateReportEffects } from "./report/aggregate-report/aggregate-report.effects";
import { AggregateReportReducers } from "./report/aggregate-report/aggregate-report.reducers";
import { PrintState } from "./print/print.state";
import { PrintReducer } from "./print/print.reducer";

export const CourseIdReducer: ActionReducer<number, Action> = createReducer(
  0,
  on(SetCourseId, (_state, action): number => {
    return action.courseId;
  })
);

export interface StoreState {
  courseId: number;
  skillsCheckTabState: SkillsCheckState;
  learningRecordTabState: LearningRecordTabState;
  editAdministratorState: EditAdministratorState;
  formAdministratorState: FormAdministratorState;
  learningPlanState: LearningPlanState;
  skillsCheckQandAState: SkillsCheckQandAState;
  organisationState: OrganisationState;
  centreState: CentreState;
  navigationState: NavigationState;
  groupState: GroupState;
  tutorState: TutorState;
  tutorEditState: TutorEditState;
  tutorDeleteState: TutorDeleteState;
  roleState: RoleState;
  userProfileState: UserProfileState;
  courseState: CourseState;
  createLearnerState: CreateLearnerState;
  learnerState: LearnerState;
  dateProviderState: DateProviderState;
  editLearnerState: EditLearnerState;
  listAdministratorState: ListAdministratorState;
  learnerCourseState: LearnerCourseState;
  courseContentMetadataState: CourseContentMetadataState;
  learningTrackingState: LearningTrackingState;
  editGroupState: EditGroupState;
  learnerOfflineActivityState: LearnerOfflineActivityState;
  learningResourcesState: LearningResourcesState;
  externalInitialAssessmentState: ExternalInitialAssessmentState;
  assessmentProfileState: AssessmentProfileState;
  learnerResourcesState: LearnerResourcesState;
  transferLearnerState: TransferLearnerState;
  eventHistoryState: EventHistoryState;
  digLitSelfAssessmentState: DigLitSelfAssessmentState;
  resetMFAState: ResetMFAState;
  learnerReportState: LearnerReportState;
  writtenAssignmentRecordState: WrittenAssignmentRecordState;
  importState: ImportState;
  importExternalResultsState: ImportExternalResultsState;
  importBatchDisableDeleteState: ImportBatchDisableDeleteState;
  aggregateReportsState: AggregateReportState;
  printState: PrintState;
}

export const initialStoreState: StoreState = onStoreInit();

export const storeEffects = [
  SkillsCheckTabEffects,
  LearningRecordTabEffect,
  FormAdministratorEffects,
  EditAdministratorEffects,
  LearningPlanEffects,
  SkillsCheckQandAEffects,
  OrganisationEffects,
  CentreEffects,
  NavigationStateEffects,
  GroupEffects,
  TutorEffects,
  TutorEditEffects,
  TutorDeleteEffects,
  RoleEffects,
  UserProfileEffects,
  CourseEffects,
  CreateLearnerEffects,
  LearnerEffects,
  DateProviderEffects,
  EditLearnerEffects,
  ListAdministratorEffects,
  LearnerCourseEffects,
  CourseContentMetadataEffects,
  LearningTrackingStateEffects,
  EditGroupEffects,
  LearnerOfflineActivityEffects,
  LearningResourcesEffects,
  ExternalInitialAssessmentEffects,
  AssessmentProfileEffects,
  LearnerResourcesEffects,
  TransferLearnerEffects,
  EventHistoryEffects,
  DigLitSelfAssessmentEffects,
  ResetMFAEffects,
  LearnerReportEffects,
  WrittenAssignmentRecordEffects,
  ImportEffects,
  ImportExternalResultsEffects,
  ImportBatchDisableDeleteEffects,
  AggregateReportEffects
];

export const storeReducers: ActionReducerMap<StoreState> = {
  courseId: CourseIdReducer,
  skillsCheckTabState: SkillsCheckTabReducers,
  learningRecordTabState: LearningRecordTabReducer,
  editAdministratorState: EditAdministratorReducers,
  formAdministratorState: FormAdministratorReducers,
  learningPlanState: LearningPlanReducers,
  skillsCheckQandAState: SkillsCheckQandAReducers,
  organisationState: OrganisationReducers,
  centreState: CentreReducers,
  navigationState: NavigationReducers,
  groupState: GroupReducers,
  tutorState: TutorReducers,
  tutorEditState: TutorEditReducers,
  tutorDeleteState: TutorDeleteReducers,
  roleState: RoleReducers,
  userProfileState: UserProfileReducer,
  courseState: CourseReducers,
  createLearnerState: CreateLearnerReducers,
  learnerState: LearnerReducers,
  dateProviderState: DateProviderReducer,
  editLearnerState: EditLearnerReducers,
  listAdministratorState: ListAdminstratorReducers,
  learnerCourseState: LearnerCourseReducers,
  courseContentMetadataState: CourseContentMetadataReducers,
  learningTrackingState: LearningTrackingReducers,
  editGroupState: EditGroupReducers,
  learnerOfflineActivityState: LearnerOfflineActivityReducers,
  learningResourcesState: LearningResourcesReducers,
  externalInitialAssessmentState: ExportInitialAssessmentReducers,
  assessmentProfileState: AssessmentProfileReducers,
  learnerResourcesState: LearnerResourcesReducers,
  transferLearnerState: TransferLearnerReducers,
  eventHistoryState: EventHistoryReducers,
  digLitSelfAssessmentState: DigLitSelfAssessmentReducer,
  resetMFAState: ResetMFAReducers,
  learnerReportState: LearnerReportReducers,
  writtenAssignmentRecordState: WrittenAssignmentRecordsReducers,
  importState: ImportReducers,
  importExternalResultsState: ImportExternalResultsReducers,
  importBatchDisableDeleteState: ImportBatchDisableDeleteReducers,
  aggregateReportsState: AggregateReportReducers,
  printState: PrintReducer
};
